"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createContactUsEmailLink = exports.addDefaultSnackbarOptions = exports.mapOptionsToSnackbar = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const SnackbarError_1 = tslib_1.__importDefault(require("./SnackbarError/SnackbarError"));
const SnackbarInfo_1 = tslib_1.__importDefault(require("./SnackbarInfo"));
const SnackbarSuccess_1 = tslib_1.__importDefault(require("./SnackbarSuccess"));
function mapOptionsToSnackbar(options, closeSnackbar) {
    try {
        const { variant, key, message, actionButton } = options;
        if (!message) {
            return react_1.default.createElement(SnackbarError_1.default, { message: "Snackbar message was not defined", closeSnackbar: closeSnackbar });
        }
        /* Only the error snackbar are allowed to have title and contact us button */
        if (variant === "error") {
            const { title, contactUs } = options;
            return react_1.default.createElement(SnackbarError_1.default, { ...{ key, message, title, contactUs, actionButton, closeSnackbar } });
        }
        else if (variant === "info")
            return react_1.default.createElement(SnackbarInfo_1.default, { ...{ key, message, actionButton, closeSnackbar } });
        else if (variant === "success")
            return react_1.default.createElement(SnackbarSuccess_1.default, { ...{ key, message, actionButton, closeSnackbar } });
        else
            return react_1.default.createElement(SnackbarError_1.default, { message: "Snackbar variant wast not defined", closeSnackbar: closeSnackbar });
    }
    catch (error) {
        const stringifiedError = JSON.stringify(error, Object.getOwnPropertyNames(error), 2);
        return (react_1.default.createElement(SnackbarError_1.default, { ...{ message: `An error occured while rendering the snackbar: \n ${stringifiedError}}`, closeSnackbar } }));
    }
}
exports.mapOptionsToSnackbar = mapOptionsToSnackbar;
/** Adds default values to the snackbar options */
const addDefaultSnackbarOptions = ({ variant, ...rest }) => ({
    persist: mapVariantToPersist(variant),
    anchorOrigin: mapVariantToAchorOrigin(variant),
    variant,
    ...rest,
});
exports.addDefaultSnackbarOptions = addDefaultSnackbarOptions;
const mapVariantToPersist = (variant) => variant === "error";
const mapVariantToAchorOrigin = (variant) => {
    if (variant === "error") {
        return { vertical: "top", horizontal: "right" };
    }
    else {
        return { vertical: "bottom", horizontal: "center" };
    }
};
const createContactUsEmailLink = (errorDetails) => {
    const body = `
URL: ${window.location.href}
Environment: ${navigator.userAgent} 
Timestamp: ${new Date().toISOString()} 
Payload: ${new Date().toISOString()}
URL: ${window.location.href} \n
Payload:
${errorDetails}
`;
    return `mailto:developers@mnemonic.no?subject=Error enocuntered in snackbar&body=${encodeURIComponent(body)}`;
};
exports.createContactUsEmailLink = createContactUsEmailLink;
